import { object } from 'common/helpers'


export const initialState = {
  isFetching: false,
  products: [],
}

export const setFetching = (state, payload) => (
  object.set(state, 'isFetching', payload)
)

export const set = (state, payload) => ({
  ...state,
  ...payload,
  isFetching: false,
})
